import { z } from 'zod';

export const REMEMBERED_EMAIL_LOCAL_STORAGE_KEY = 'rememberedEmail';

export const validationSchema = z.object({
  email: z.string().email({
    message: 'i18n.auth.signIn.form.email.error',
  }),
  password: z.string().min(8, {
    message: 'i18n.auth.signIn.form.password.error|{"min":8}',
  }),
  rememberMe: z.boolean(),
});

export type FormValues = z.infer<typeof validationSchema>;

export const getDefaultValues = (): FormValues => ({
  email: localStorage.getItem(REMEMBERED_EMAIL_LOCAL_STORAGE_KEY) ?? '',
  password: '',
  rememberMe: localStorage.getItem(REMEMBERED_EMAIL_LOCAL_STORAGE_KEY) !== null,
});
